import React, {useState, useContext} from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol } from '@ionic/react';
import { IonImg, IonLabel } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import {Plugins, CameraResultType } from '@capacitor/core';

import '../../../css/qavaApp.css';
import {  UploadedInvoiceTemplates } from '../components/clientAccountSettingAppComps';

import { UpdatePayMethod_CheckingModal } from '../../appsecure_components/Modal_UpdatePayMethod_Checking';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';


const { Filesystem } = Plugins;
const { Camera } = Plugins;


export function Client_AccountSetting () {

    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    let [showFormTemplates, setShowFormTemplates] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [showCompanySetting_onlineImageModal, setShowCompanySetting_onlineImageModal] = useState(false);
    let [showCompanySetting_selectedImageModal, setShowCompanySetting_selectedImageModal] = useState(false);
    let [companyOnlineImage, setCompanyOnlineImage] = useState(null);
    let [enlarge_selectedShowcaseImage, setEnlarge_selectedShowcaseImage] = useState(null);

    let [updatePayMethodModal, setUpdatePayMethodModal] = useState(null);

    
    
    function saveUploadedFile(event) {
    
        setSelectedFile(event.target.files[0]);

    }



    async function uploadFile() {

        /*let file = await Filesystem.readFile({
            path: selectedFile,
            directory: FilesystemDirectory.Documents,
            encoding: FilesystemEncoding.UTF8
        })

        let fileeUrl = file.webPath;
        let filePath = file.path;*/

        const formData = new FormData();
        formData.append('originalFormFile', selectedFile);
        formData.append('Tracker', 72003);
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch('https://ghanaverified.com/merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })
    }



    return (
            <IonReactRouter>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle size="large" class="appTitle">QAVA</IonTitle>
                        <IonTitle size="small" class="appTitle" > { acctID } </IonTitle>
                        <IonTitle size="large" class="appTitle" > { schema } </IonTitle>
                        <IonButtons slot='end'>
                            <IonMenuButton autoHide='false'></IonMenuButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonList class="invoiceSettings">
                        <IonModal id='showInvoiceTemplates' isOpen={ showInvoiceTemplates }>
                            <UploadedInvoiceTemplates accountID= { acctID } schemaName={ schema }/>

                            <IonButton onClick={() => setShowInvoiceTemplates(false)}>
                                Close Modal
                            </IonButton>
                        </IonModal>
                        <IonTitle size='large'>Invoices</IonTitle>
                        <IonItem> 
                            <h1>Upload Invoice Template</h1>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <input type='file' name='imageFile' accept="image/*" onChange={(e) => saveUploadedFile(e)}></input>
                                <input type="button" value="upload" onClick={uploadFile} ></input>
                            </form>
                        </IonItem> 
                        <h1>Status</h1>
                        <IonButton onClick={() => setShowInvoiceTemplates(true)}>View Invoice Uploaded</IonButton>
                    </IonList>
                    <IonList class="formsSettings">
                        <IonModal id='showFormTemplates' isOpen={showFormTemplates}>
                            <IonGrid class="settingTable">
                                <IonRow>
                                    <IonCol>
                                        <h1>Image ID</h1>
                                    </IonCol>
                                    <IonCol>
                                        <h1>Original Image</h1>
                                        
                                    </IonCol>
                                    <IonCol>
                                        <h1>Postscript Image</h1>
                                    </IonCol>
                                    <IonCol>
                                        <h1>Actons</h1>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        <IonButton onClick={() => setShowFormTemplates(false)}>
                            Close Modal
                        </IonButton>
                        </IonModal>
                        <IonTitle size='large'>Forms</IonTitle>
                        <IonItem> 
                            <h1>Upload Form Template</h1>
                            <IonButton>Browse</IonButton>
                            <IonButton>upload</IonButton>
                        </IonItem> 
                        <IonItem> 
                            <h1>Status</h1>
                            <IonButton onClick={() => setShowFormTemplates(true)}>View Forms Uploaded</IonButton>
                        </IonItem>
                    </IonList>
                    <IonList>
                        <IonTitle size='large'>Payment Methods</IonTitle>
                        <IonItem> 
                            <IonButton onClick={() => setUpdatePayMethodModal(true)}>checking</IonButton>
                        </IonItem> 

                        <UpdatePayMethod_CheckingModal openModal={ updatePayMethodModal } closeModal={() => setUpdatePayMethodModal(false)} tracker={'73003A'} acctID={acctID}></UpdatePayMethod_CheckingModal>

                    </IonList>
                </IonContent>
            </IonReactRouter>
    );
};



export default Client_AccountSetting;